import PropTypes from "prop-types";
import { ICON_SIZES } from "app/constants";
function TicketFilledIcon({ size, ...props }) {
	return (
		<svg
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...size !== undefined && { width: size, height: size }}
			{...props}
		>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M9.75 20.75H20C21.5188 20.75 22.75 19.5188 22.75 18V14.5C22.75 14.0858 22.4142 13.75 22 13.75C21.0335 13.75 20.25 12.9665 20.25 12C20.25 11.0335 21.0335 10.25 22 10.25C22.4142 10.25 22.75 9.91421 22.75 9.5V6C22.75 4.48122 21.5188 3.25 20 3.25H9.75V20.75ZM8.25 3.25H4C2.48122 3.25 1.25 4.48122 1.25 6V9.5C1.25 9.91421 1.58579 10.25 2 10.25C2.9665 10.25 3.75 11.0335 3.75 12C3.75 12.9665 2.9665 13.75 2 13.75C1.58579 13.75 1.25 14.0858 1.25 14.5V18C1.25 19.5188 2.48122 20.75 4 20.75H8.25V3.25Z"
				fill="currentColor"
			/>
		</svg>
	);
}

TicketFilledIcon.propTypes = {
	size: PropTypes.oneOf(Object.values(ICON_SIZES)),
};

export default TicketFilledIcon;
